import axios from 'axios'
import Vue from 'vue'
import helpers from '@/utils/helpers'
import VueCookies from 'vue-cookies'
import {store} from '@/integrations/store'
import {eventBus} from '@/utils/eventBus'
const KEY = document.querySelector('meta[name="app-key"]').content
const API_URL = document.querySelector('meta[name="app-url"]').content

Vue.use(VueCookies)

export const API = axios.create({
  baseURL: API_URL,
  headers: {
    'app-key': KEY
  }
})

const AXIOS = axios.create({
  baseURL: API_URL,
  headers: {
    'access-token': helpers.isPreviewFrame() ? store.getters['user/userTokenAdmin'] : store.getters['user/userTokenAccess']
  }
})

API.interceptors.response.use(
  response => response,
  error => {
    switch (error.response.status) {
      case 422:
        error.response.data.forEach(error => {
          if (error.field === '_popup') {
            return eventBus.$emit('popup', error.message)
          }
        })
        break
    }

    return Promise.reject(error)
  }
)

AXIOS.interceptors.response.use(
  response => {
    const CORE_VER = Vue.$cookies.get('core_ver')
    if (!CORE_VER && response.headers['x-core-ver']) Vue.$cookies.set('core_ver', response.headers['x-core-ver'])
    if (CORE_VER && response.headers['x-core-ver'] && String(CORE_VER) !== String(response.headers['x-core-ver'])) {
      Vue.$cookies.set('core_ver', response.headers['x-core-ver'])
      caches.keys().then(function (cacheNames) {
        for (let name of cacheNames) caches.delete(name)
        let timeout = (Math.floor(Math.random() * (20 - 1)) + 1) * 100 // 100...2000 ms step 100
        setTimeout(() => {
          window.location.reload(true)
        }, timeout)
      })
    }
    return response
  },
  error => {
    switch (error.response.status) {
      case 401:
        store.commit('user/userLogOut')
        window.location.reload()
        break
      case 404:
        eventBus.$emit('404')
        break
      case 406:
        eventBus.$emit('goToRootModule')
        break
      case 422:
        error.response.data.forEach(error => {
          if (error.field === '_popup') {
            return eventBus.$emit('popup', error.message)
          }
        })

        break
      case 451:
        store.commit('setAppState', false)
        break
    }
    if (error.response.status === 406) return
    return Promise.reject(error)
  }
)

export default AXIOS
